<simple-table-card class="" [simpleCard]="cardData.simpleDataTableData">
</simple-table-card>
